<template>
  <div class="page-container">
    <div class="page-card">
      <div class="page-card__header">
        <h1 class="section-title">{{ title }}</h1>
        <p v-if="publishDate" class="detail-meta">发布日期：{{ publishDate }}</p>
      </div>
      <div class="page-card__body">
        <div class="detail-content" v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { detail } from '@/api/cmsApi'

export default {
  name: 'DetailView',
  data() {
    return {
      publishDate: '',
      content: '',
      title: ''
    }
  },
  created() {
    this.query()
  },
  watch: {
    '$route.query.id'() {
      this.query()
    }
  },
  methods: {
    query() {
      detail({ id: this.$route.query.id }).then(res => {
        if (res.code === 200) {
          this.publishDate = res.data.publishDate
          this.content = res.data.content
          this.title = res.data.title
        }
      })
    }
  }
}
</script>
